import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Identificator } from '../../models/custom-types';
import { VisualizationType } from '../../enums/visualization-type.enum';
import { Observable } from 'rxjs';
import { HttpUtils } from '../../utils/http.utils';

@Injectable()
export class VisualizationApi {
  #httpClient: HttpClient = inject(HttpClient);
  readonly #apiUrl = environment.API_EWNIOSKI + '/visualization';

  getVisualization$(
    id: Identificator,
    visualizationType: VisualizationType,
  ): Observable<string> {
    return this.#httpClient.get(`${this.#apiUrl}`, {
      params: HttpUtils.toHttpParams({
        idDokumentu: id,
        visualizationType: visualizationType,
      }),
      responseType: 'text',
      withCredentials: true,
    });
  }
}
